export default __webpack_public_path__ + "static/media/aditya.47bae0bb.png";